import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

const attributes = [
  'id',  
  'created_at', 
  'updated_at',
  { template: [ 'id', 'name', { file: ['id', 'representations', 'filename', 'url'] }] },
];
const fullAttributes = [
  'id', 
  'created_at', 
  'updated_at',
  { template: [
      'id',
      'name',
      'created_at', 
      'updated_at',
      { file: ['id', 'representations', 'filename', 'url'] },
      { pages: ['id', 'number', 'height'] },
      { elements: ['id', 'elementable', 'elementable_type', 'x', 'y', 'width', 'height', { page: ['id', 'number'] }] }
    ] 
  }
];

export const getEsignTemplates = asyncThunkWrapper({ 
  model: 'esignTemplates', 
  action: 'getEsignTemplates', 
  func: async ({ offset = 0 }) => {
    const params = { attributes, limit: 25, offset, orders: { created_at: 'desc' } };
    const response = await axios.get('/esign_flow/esign_templates', { params });

    return response.data;
  } 
});
export const getEsignTemplate = asyncThunkWrapper({ 
  model: 'esignTemplates', 
  action: 'getEsignTemplate', 
  func: async (id) => {
    const params = { attributes: fullAttributes };
    const response = await axios.get(`/esign_templates/${id}`, { params });

    return response.data;
  } 
});
export const createEsignTemplate = asyncThunkWrapper({ 
  model: 'esignTemplates', 
  action: 'createEsignTemplate', 
  func: async (esignTemplate) => {
    const response = await axios.post(`/esign_flow/esign_templates`, { esign_template: esignTemplate, attributes });

    return response.data;
  } 
});
export const updateEsignTemplate = asyncThunkWrapper({ 
  model: 'esignTemplates', 
  action: 'updateEsignTemplate', 
  func: async ({ id, ...fields }) => {
    const response = await axios.patch(`/esign_templates/${id}`, { esign_template: { id, ...fields } });

    return { status: response.status, esignTemplate: { ...fields } };
  } 
});
export const deleteEsignTemplate = asyncThunkWrapper({ 
  model: 'esignTemplates', 
  action: 'deleteEsignTemplate', 
  func: async (id) => {
    const response = await axios.delete(`/esign_templates/${id}`);

    return { status: response.status, id };
  } 
});
export const clearLocalEsignTemplates = createAction('esignTemplates/clearLocalEsignTemplates');
export const clearLocalActiveEsignTemplate = createAction('esignTemplates/clearLocalActiveEsignTemplate');